import axios from "axios";
import API_BASE_URL from "../config";

const NewsLetter_API = `${API_BASE_URL}/newsletter`; // Backend API URL

export const subscribeToNewsletter = async (email) => {
    try {
        const response = await axios.post(`${NewsLetter_API}/subscribe`, { email });
        return response.data;
    } catch (error) {
        console.error("Error subscribing to newsletter:", error.response?.data || error.message);
        
        return { 
            Success: false, 
            Message: error.response?.data?.Message || "An error occurred while subscribing." 
        }; // ✅ Returning an object instead of throwing an error
    }
};
